import React, { createContext, useState, useContext, useEffect } from "react";
import ru from "../assets/flags/ru.png";

import ruJson from "./ru.json";

const mapTranslations = (arr) => {
	if (!Array.isArray(arr)) return arr || {};
	return arr.reduce((acc, item) => {
		acc[item.code] = item.val;
		return acc;
	}, {});
};

const translations = {
	ru: mapTranslations(ruJson),
};

// Language data
export const languageOptions = [
	{ value: "ru", label: "Русский", icon: ru },
];

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
	const [language, setLanguage] = useState("ru");
	const [currentTranslations, setCurrentTranslations] = useState(
		translations[language] || {},
	);

	useEffect(() => {
		setCurrentTranslations(translations[language] || {});
	}, [language]);

	const changeLanguage = (lang) => {
		setLanguage(lang);
		localStorage.setItem("lang", lang);
	};

	const t = (key) => currentTranslations[key] || key;

	return (
		<TranslationContext.Provider
			value={{ language, changeLanguage, t, languageOptions }}
		>
			{children}
		</TranslationContext.Provider>
	);
};

export const useTranslation = () => useContext(TranslationContext);
